import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step7 } from '../../../../shared/models/component-messages/mapaIN/step7';
import { TypeLangue } from '../models/TypeLangue';
@Component({
  selector: 'app-type-langue',
  templateUrl: './type-langue.component.html'
})
export class TypeLangueComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeLangue';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() langue: TypeLangue;

  public step7 = new Step7();

  constructor() { }

  public ngOnInit() {
    if (this.langue == undefined || this.langue === null) {
      this.langue = new TypeLangue();
    }
  }
  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

